import { schema } from 'normalizr'

export const supplementsEntity = new schema.Entity(
  'supplements',
  {},
  {
    idAttribute: 'productId',
  },
)



// WEBPACK FOOTER //
// ./src/config/normalizrSchema.js